/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCustomContactForm = {
  init: function () {

    // Selectors
//     const $contactForm = $('.contact-form__form');

//     // Contact form checkbox validation
//     if ($('[data-is-required]').length){
//       var $checkboxGroup = $('.contact-form__list .checkbox');
//       $checkboxGroup.prop('required', true);

//       $('.contact-form__list .checkbox').on('change', function(){
//         $checkboxGroup.prop('required', true);
//         if ($checkboxGroup.is(":checked")) {
//           $checkboxGroup.prop('required', false);
//         }
//       })
//     }

//     $('.custom-contact-form input.button').click(function(){
//       $(".custom-contact-form .custom-contact-form__block input, .custom-contact-form .custom-contact-form__block textarea").each(function() {
//         if($(this).val() === "") {
//           $(".custom-contact-form").submit(function(){
//           	return false;
//           });
//         }
//       });
//     })
//     $('.custom-contact-form span.button-submit').click(function(e){
//       //$(".custom-contact-form").valid();
// 		e.preventDefault()
//         console.log(22)
//       $(".custom-contact-form").validate({
//         onfocusout: true,
//         onkeyup: true,
//         onclick: true,
//         focusInvalid: true,
//         highlight: function(element, errorClass, validClass) {
//           $(element).parents('.wrap-field').addClass('has-error');
//           console.log('has-error');
//         },
//         unhighlight: function(element, errorClass, validClass) {
//           $(element).parents('.wrap-field').removeClass('has-error');
//           $(element).parents('.wrap-field').addClass('has-success');
//           console.log(element);
//         },
//         submitHandler: function(form) { // <- pass 'form' argument in
//           //$("input.button").show;
//           console.log('ajax');
//           $(form).ajaxSubmit(); // <- use 'form' argument here.
//           //           $(".custom-contact-form input.button").click(); // <- use 'form' argument here.
//         }
//       });
//     });
  	$(".custom-contact-form").append('<input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓">')
    $(".custom-contact-form").validate({
      submitHandler: function(form) { // <- pass 'form' argument in
        //$("input.button").show;
        window.Shopify.recaptchaV3.addToken(form, "contact"); 
        return false;
        //$(form).ajaxSubmit(); // <- use 'form' argument here.
        //           $(".custom-contact-form input.button").click(); // <- use 'form' argument here.
      }
    });
//     if($('.custom-contact-form .custom-contact-form__block input[name="contact[Name]"]').val() != "" 
//        && $('.custom-contact-form .custom-contact-form__block input["contact[email]"]').val() != ""
//        && $('.custom-contact-form .custom-contact-form__block input["contact[number]"]').val() != ""
//        && $('.custom-contact-form .custom-contact-form__block textarea').val() != "") {
//       $('.custom-contact-form span.button-submit').hide();
//       $('.custom-contact-form input.button').show();
//     }else {
//       $('.custom-contact-form span.button-submit').show();
//       $('.custom-contact-form input.button').hide();
//     }
//     $('.custom-contact-form .custom-contact-form__block').each(function(){
//       $('.custom-contact-form .custom-contact-form__block input,.custom-contact-form .custom-contact-form__block textarea').on('focus change keyup paste', function() {
//         if($('.custom-contact-form .custom-contact-form__block input[name="contact[Name]"]').val() != "" 
//            && $('.custom-contact-form .custom-contact-form__block input[name="contact[email]"]').val() != ""
//            && $('.custom-contact-form .custom-contact-form__block input[name="contact[number]"]').val() != ""
//            && $('.custom-contact-form .custom-contact-form__block textarea').val() != "") {
//           $('.custom-contact-form span.button-submit').hide();
//           $('.custom-contact-form input.button').show();
//         }else {
//           $('.custom-contact-form span.button-submit').show();
//           $('.custom-contact-form input.button').hide();
//         }
//       })
//     })

//     $contactForm.on('submit', function(e) {

//       const $form = $(this);
//       const $formBlocks = $('.contact-form__blocks [data-checkbox-required]', $form);
//       const $errorMessage = Shopify.translation.contact_form_checkbox_error;
//       const $errorMessageContainer = $('.form__error', $form);

//       let completeForm = true;

//       for (let i = 0; i < $formBlocks.length; i++ ) {
//         const $checkbox = $('input[type=checkbox]:checked', $formBlocks[i]);
//         if ($checkbox.length) {
//           completeForm = true;
//         } else {
//           $errorMessageContainer.html($errorMessage);
//           completeForm = false;
//         }
//       }

//       if (completeForm) {
//         return;
//       } else {
//         event.preventDefault();
//       }
//     });
  },
//   unload: function () {
//     const $contactForm = $('.contact-form__form');
//     const $submitButton = $contactForm.find(':submit');

//     $submitButton.off();

//   }
}

/******/ })()
;